/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ displayName: NonNullable<unknown>, buttonText: NonNullable<unknown> }} Step_Away_Product_MessageInputs */

const en_step_away_product_message = /** @type {(inputs: Step_Away_Product_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You're only a step away from ${i?.displayName}. Just enter your email address and click/tap <span class='font-bold'>${i?.buttonText}</span> to get started.`)
};

const id_step_away_product_message = /** @type {(inputs: Step_Away_Product_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Anda hanya selangkah lagi dari ${i?.displayName}. Cukup masukkan alamat email Anda dan klik/ketuk <span class='font-bold'>${i?.buttonText}</span> untuk memulai.`)
};

const ms_step_away_product_message = /** @type {(inputs: Step_Away_Product_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Anda hanya selangkah lagi dari ${i?.displayName}. Masukkan sahaja alamat e-mel anda dan klik/ketik <span class='font-bold'>${i?.buttonText}</span> untuk bermula.`)
};

const ca_step_away_product_message = /** @type {(inputs: Step_Away_Product_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Estàs a un pas de ${i?.displayName}. Només cal que introdueixis la teva adreça de correu electrònic i facis clic/toca <span class='font-bold'>${i?.buttonText}</span> per començar.`)
};

const cs_step_away_product_message = /** @type {(inputs: Step_Away_Product_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Jste jen krok od ${i?.displayName}. Stačí zadat e-mailovou adresu a kliknout/klepnout na <span class='font-bold'>${i?.buttonText}</span>.`)
};

const da_step_away_product_message = /** @type {(inputs: Step_Away_Product_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du er kun ét skridt fra ${i?.displayName}. Indtast blot din e-mailadresse og klik/tryk på <span class='font-bold'>${i?.buttonText}</span> for at komme i gang.`)
};

const de_step_away_product_message = /** @type {(inputs: Step_Away_Product_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nur noch ein Schritt, dann können Sie ${i?.displayName} nutzen. Geben Sie einfach Ihre E-Mail-Adresse ein und klicken Sie auf <span class='font-bold'>${i?.buttonText}</span>, um loszulegen.`)
};

const et_step_away_product_message = /** @type {(inputs: Step_Away_Product_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Oled ${i?.displayName}-st vaid ühe sammu kaugusel. Sisesta lihtsalt oma e-posti aadress ja klõpsa/puuduta <span class='font-bold'>${i?.buttonText}</span>, et alustada.`)
};

const es_step_away_product_message = /** @type {(inputs: Step_Away_Product_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Estás a un paso de ${i?.displayName}. Solo ingresa tu dirección de correo electrónico y haz clic/toca <span class='font-bold'>${i?.buttonText}</span> para comenzar.`)
};

const fr_step_away_product_message = /** @type {(inputs: Step_Away_Product_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vous n'êtes qu'à un pas de ${i?.displayName}. Saisissez simplement votre adresse e-mail et cliquez sur <span class='font-bold'>${i?.buttonText}</span> pour commencer.`)
};

const hr_step_away_product_message = /** @type {(inputs: Step_Away_Product_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Samo ste jedan korak od ${i?.displayName}. Unesite svoju adresu e-pošte i kliknite/dodirnite <span class='font-bold'>${i?.buttonText}</span> da biste počeli.`)
};

const it_step_away_product_message = /** @type {(inputs: Step_Away_Product_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Quasi tutto pronto per ${i?.displayName}. Inserisci il tuo indirizzo email e fai clic su/tocca <span class='font-bold'>${i?.buttonText}</span> per iniziare.`)
};

const lv_step_away_product_message = /** @type {(inputs: Step_Away_Product_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Jūs esat tikai soli no ${i?.displayName}. Vienkārši ievadiet savu e-pasta adresi un noklikšķiniet/pieskarieties <span class='font-bold'>${i?.buttonText}</span>, lai sāktu.`)
};

const lt_step_away_product_message = /** @type {(inputs: Step_Away_Product_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Iki svetainės ${i?.displayName} liko tik vienas žingsnis. Tiesiog įveskite savo el. pašto adresą ir spustelėkite / bakstelėkite <span class='font-bold'>${i?.buttonText}</span>, kad pradėtumėte.`)
};

const hu_step_away_product_message = /** @type {(inputs: Step_Away_Product_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Csak egy lépésre van a ${i?.displayName}-tól/-től/-ről. Adja meg e-mail címét, majd kattintson a <span class='font-bold'>${i?.buttonText}</span> gombra a kezdéshez.`)
};

const nl_step_away_product_message = /** @type {(inputs: Step_Away_Product_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Je bent nog maar één stap verwijderd van ${i?.displayName}. Voer gewoon je e-mailadres in en klik/tik op <span class='font-bold'>${i?.buttonText}</span> om te beginnen.`)
};

const nb_step_away_product_message = /** @type {(inputs: Step_Away_Product_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du er bare ett steg unna ${i?.displayName}. Bare skriv inn e-postadressen din og klikk/trykk <span class='font-bold'>${i?.buttonText}</span> for å komme i gang.`)
};

const pl_step_away_product_message = /** @type {(inputs: Step_Away_Product_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dzieli Cię tylko jeden krok od ${i?.displayName}. Wpisz swój adres e-mail i kliknij/dotknij <span class='font-bold'>${i?.buttonText}</span>, aby rozpocząć.`)
};

const pt_step_away_product_message = /** @type {(inputs: Step_Away_Product_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Você está a apenas um passo de ${i?.displayName}. Basta inserir seu endereço de e-mail e clicar/tocar em <span class='font-bold'>${i?.buttonText}</span> para começar.`)
};

const ro_step_away_product_message = /** @type {(inputs: Step_Away_Product_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ești la un pas distanță de ${i?.displayName}. Introdu adresa de email și apasă <span class='font-bold'>${i?.buttonText}</span> pentru a începe.`)
};

const sk_step_away_product_message = /** @type {(inputs: Step_Away_Product_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ste len krok od ${i?.displayName}. Stačí zadať e-mailovú adresu a kliknúť/ťuknúť na <span class='font-bold'>${i?.buttonText}</span>, aby ste mohli začať.`)
};

const sl_step_away_product_message = /** @type {(inputs: Step_Away_Product_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Le korak vas loči od ${i?.displayName}. Vnesite svoj e-poštni naslov in kliknite/tapnite <span class='font-bold'>${i?.buttonText}</span> za začetek.`)
};

const fi_step_away_product_message = /** @type {(inputs: Step_Away_Product_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Olet vain askeleen päässä palvelusta ${i?.displayName}. Syötä vain sähköpostiosoitteesi ja napsauta/napauta <span class='font-bold'>${i?.buttonText}</span> aloittaaksesi.`)
};

const sv_step_away_product_message = /** @type {(inputs: Step_Away_Product_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du är bara ett steg från ${i?.displayName}. Ange bara din e-postadress och klicka/tryck på <span class='font-bold'>${i?.buttonText}</span> för att komma igång.`)
};

const vi_step_away_product_message = /** @type {(inputs: Step_Away_Product_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bạn chỉ cách ${i?.displayName} một bước. Chỉ cần nhập địa chỉ email của bạn và nhấp/chạm vào <span class='font-bold'>${i?.buttonText}</span> để bắt đầu.`)
};

const tr_step_away_product_message = /** @type {(inputs: Step_Away_Product_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.displayName} ürününe bir adım kaldı. Başlamak için e-posta adresinizi girin ve <span class='font-bold'>${i?.buttonText}</span> butonuna tıklayın/dokunun.`)
};

const el_step_away_product_message = /** @type {(inputs: Step_Away_Product_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Απέχετε μόλις ένα βήμα από το ${i?.displayName}. Απλώς εισαγάγετε τη διεύθυνση email σας και κάντε κλικ/πατήστε <span class='font-bold'>${i?.buttonText}</span> για να ξεκινήσετε.`)
};

const bg_step_away_product_message = /** @type {(inputs: Step_Away_Product_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Само една стъпка ви дели от ${i?.displayName}. Просто въведете своя имейл адрес и натиснете <span class='font-bold'>${i?.buttonText}</span>, за да започнете.`)
};

const ru_step_away_product_message = /** @type {(inputs: Step_Away_Product_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Вы в одном шаге от ${i?.displayName}. Просто введите адрес электронной почты и нажмите <span class='font-bold'>${i?.buttonText}</span>, чтобы начать.`)
};

const sr_step_away_product_message = /** @type {(inputs: Step_Away_Product_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Samo još jedan korak do ${i?.displayName}. Unesite svoju email adresu i kliknite/tapnite <span class='font-bold'>${i?.buttonText}</span> da biste počeli.`)
};

const uk_step_away_product_message = /** @type {(inputs: Step_Away_Product_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ви лише за крок від ${i?.displayName}. Просто введіть свою електронну адресу та натисніть <span class='font-bold'>${i?.buttonText}</span>, щоб розпочати.`)
};

const ka_step_away_product_message = /** @type {(inputs: Step_Away_Product_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`თქვენ მხოლოდ ერთი ნაბიჯი გაშორებთ ${i?.displayName}-ს. უბრალოდ შეიყვანეთ თქვენი ელ. ფოსტის მისამართი და დააჭირეთ <span class='font-bold'>${i?.buttonText}</span> დასაწყებად.`)
};

const hi_step_away_product_message = /** @type {(inputs: Step_Away_Product_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`आप ${i?.displayName} से बस एक कदम दूर हैं। बस अपना ईमेल पता दर्ज करें और शुरू करने के लिए <span class='font-bold'>${i?.buttonText}</span> पर क्लिक/टैप करें।`)
};

const th_step_away_product_message = /** @type {(inputs: Step_Away_Product_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`คุณอยู่ห่างจาก ${i?.displayName} เพียงขั้นตอนเดียว เพียงกรอกที่อยู่อีเมลของคุณแล้วคลิก/แตะ <span class='font-bold'>${i?.buttonText}</span> เพื่อเริ่มต้นใช้งาน`)
};

const ko_step_away_product_message = /** @type {(inputs: Step_Away_Product_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.displayName}까지 한 단계만 남았습니다. 이메일 주소를 입력하고 <span class='font-bold'>${i?.buttonText}</span>을(를) 클릭/탭하여 시작하세요.`)
};

const zh_step_away_product_message = /** @type {(inputs: Step_Away_Product_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`离 ${i?.displayName}仅一步之遥。只需输入您的电子邮件地址，然后点击/轻点 <span class='font-bold'>${i?.buttonText}</span>即可开始使用。`)
};

const zh_tw_step_away_product_message = /** @type {(inputs: Step_Away_Product_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`您距離 ${i?.displayName} 只差一步。只需輸入您的電子郵件地址，然後點擊/按一下<span class='font-bold'>${i?.buttonText}</span>即可開始使用。`)
};

const ja_step_away_product_message = /** @type {(inputs: Step_Away_Product_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.displayName}まであと一歩です。メールアドレスを入力し、<span class='font-bold'>${i?.buttonText}</span> をクリック/タップして開始してください。`)
};

/**
* | output |
* | --- |
* | "You're only a step away from {displayName}. Just enter your email address and click/tap <span class='font-bold'>{buttonText}</span> to get started." |
*
* @param {Step_Away_Product_MessageInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const step_away_product_message = /** @type {((inputs: Step_Away_Product_MessageInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Step_Away_Product_MessageInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_step_away_product_message(inputs)
	if (locale === "ms") return ms_step_away_product_message(inputs)
	if (locale === "ca") return ca_step_away_product_message(inputs)
	if (locale === "cs") return cs_step_away_product_message(inputs)
	if (locale === "da") return da_step_away_product_message(inputs)
	if (locale === "de") return de_step_away_product_message(inputs)
	if (locale === "et") return et_step_away_product_message(inputs)
	if (locale === "es") return es_step_away_product_message(inputs)
	if (locale === "fr") return fr_step_away_product_message(inputs)
	if (locale === "hr") return hr_step_away_product_message(inputs)
	if (locale === "it") return it_step_away_product_message(inputs)
	if (locale === "lv") return lv_step_away_product_message(inputs)
	if (locale === "lt") return lt_step_away_product_message(inputs)
	if (locale === "hu") return hu_step_away_product_message(inputs)
	if (locale === "nl") return nl_step_away_product_message(inputs)
	if (locale === "nb") return nb_step_away_product_message(inputs)
	if (locale === "pl") return pl_step_away_product_message(inputs)
	if (locale === "pt") return pt_step_away_product_message(inputs)
	if (locale === "ro") return ro_step_away_product_message(inputs)
	if (locale === "sk") return sk_step_away_product_message(inputs)
	if (locale === "sl") return sl_step_away_product_message(inputs)
	if (locale === "fi") return fi_step_away_product_message(inputs)
	if (locale === "sv") return sv_step_away_product_message(inputs)
	if (locale === "vi") return vi_step_away_product_message(inputs)
	if (locale === "tr") return tr_step_away_product_message(inputs)
	if (locale === "el") return el_step_away_product_message(inputs)
	if (locale === "bg") return bg_step_away_product_message(inputs)
	if (locale === "ru") return ru_step_away_product_message(inputs)
	if (locale === "sr") return sr_step_away_product_message(inputs)
	if (locale === "uk") return uk_step_away_product_message(inputs)
	if (locale === "ka") return ka_step_away_product_message(inputs)
	if (locale === "hi") return hi_step_away_product_message(inputs)
	if (locale === "th") return th_step_away_product_message(inputs)
	if (locale === "ko") return ko_step_away_product_message(inputs)
	if (locale === "zh") return zh_step_away_product_message(inputs)
	if (locale === "zh-tw") return zh_tw_step_away_product_message(inputs)
	if (locale === "ja") return ja_step_away_product_message(inputs)
	return en_step_away_product_message(inputs)
});